module.exports = __webpack_public_path__ + "static/media/Close_Button@3x.d4fa8a3b.png";